import { render, staticRenderFns } from "./TabelaDia.vue?vue&type=template&id=27a030c6&scoped=true"
import script from "./TabelaDia.vue?vue&type=script&lang=js"
export * from "./TabelaDia.vue?vue&type=script&lang=js"
import style0 from "./TabelaDia.vue?vue&type=style&index=0&id=27a030c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a030c6",
  null
  
)

export default component.exports